import React, {Component} from 'react';
	
import {Modal} from 'antd';




export default class ImgPreview extends Component {


	constructor(props) {
		super(props);
		

	}

	componentDidMount() {

	}

	handleCancel() {
		let {handlePreviewImg}=this.props;
		handlePreviewImg(false)
	}




	

	render() {

		let {previewVisible,previewImage} = this.props;

		return(
			<div>
        			 <Modal visible={previewVisible} footer={null} onCancel={()=>this.handleCancel()}>
		          <img  style={{ width: '100%' }} src={previewImage} />
		        </Modal>
        		</div>
		);

	}
}


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/components/imgPreview.js